import React from 'react';

import PageLoader from '../../components/Common/loader/PageLoader';
import Filters from '../../components/Common/Filters/Filters';
import ChartDashboard from './ChartDashboard/ChartDashboard';
import PlanningTable from './planning-table/PlanningTable';
import PhasingTable from './phasing-table/PhasingTable';

interface Props {
  history: any;
}

interface State {
  isLoading: boolean;
  isFilterApplied: boolean;
  isCallRequired: boolean;
  isChartLoading: boolean;
  isPlanningTableLoading: boolean;
  isPhasingTableLoading: boolean;
}

export default class RollingPlan extends React.Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      isFilterApplied: false,
      isCallRequired: false,
      isChartLoading: true,
      isPlanningTableLoading: true,
      isPhasingTableLoading: true
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.isChartLoading !== this.state.isChartLoading ||
      prevState.isPlanningTableLoading !== this.state.isPlanningTableLoading ||
      prevState.isPhasingTableLoading !== this.state.isPhasingTableLoading
    ) {
      this.setState({
        isLoading: this.state.isChartLoading &&
          this.state.isPlanningTableLoading &&
          this.state.isPhasingTableLoading
      });
    }
  }

  render(): React.ReactNode {
    return (
      <React.Fragment>
        <div className="page-content">

          <PageLoader
            status={this.state.isLoading}
          />

          <Filters
            timeSelection={'multi'}
            history={this.props.history}
            onUpdateFilter={() => {
              this.setState({
                isFilterApplied: true,
                isCallRequired: true,
                isLoading: true,
                isChartLoading: true,
                isPlanningTableLoading: true,
                isPhasingTableLoading: true
              });
            }}
          />

          {
            this.state.isFilterApplied &&
            <React.Fragment>
              <ChartDashboard
                isCallRequired={this.state.isCallRequired}
                onLoadEnd={() => {
                  this.setState({
                    isCallRequired: false,
                    isChartLoading: false
                  });
                }}
              />

              <PlanningTable
                history={this.props.history}
                isCallRequired={this.state.isCallRequired}
                onLoadEnd={() => {
                  this.setState({
                    isCallRequired: false,
                    isPlanningTableLoading: false
                  });
                }}
                onUpdateStart={() => this.setState({ isLoading: true })}
                onUpdateEnd={() => {
                  this.setState({
                    isCallRequired: true,
                    isChartLoading: true,
                    isPlanningTableLoading: true,
                    isPhasingTableLoading: true
                  });
                }}
                onRunningEnd={() => this.setState({ isLoading: false })}
              />

              <PhasingTable
                history={this.props.history}
                isCallRequired={this.state.isCallRequired}
                onLoadEnd={() => {
                  this.setState({
                    isCallRequired: false,
                    isPhasingTableLoading: false
                  });
                }}
                onUpdateStart={() => this.setState({ isLoading: true })}
                onUpdateEnd={() => {
                  this.setState({
                    isCallRequired: true,
                    isChartLoading: true,
                    isPlanningTableLoading: true,
                    isPhasingTableLoading: true
                  });
                }}
                onRunningEnd={() => this.setState({ isLoading: false })}
              />
            </React.Fragment>
          }

        </div>
      </React.Fragment>
    );
  }
}
